import { Modal, Box, Typography, IconButton } from '@mui/material'
import ButtonCustom from '../button/ButtonCustom'
import styles from './LeaveModal.module.scss'

const LeaveModal = ({
	open,
	onClose,
	onLeave,
	header,
	subHeader,
	confirmBtnTxt,
}) => {
	return (
		<Modal
			open={open}
			onClose={onClose}
			aria-labelledby="leave-modal-title"
			aria-describedby="leave-modal-desc"
			className={styles.backdrop}
		>
			<Box className={styles.modal} role="dialog" aria-modal="true">
				<IconButton
					aria-label="close"
					className={styles.closeBtn}
					onClick={onClose}
					size="large"
				>
					<img src="/images/modal-close-icon.svg" alt="close" />
				</IconButton>

				<div className={styles.iconCircle} aria-hidden>
					<img src="/images/curved-arrow-left-red.svg" alt="leave" />
				</div>

				<h3 id="leave-modal-title" className={styles.title}>
					{header ?? 'Leave Conversation'}
				</h3>

				<Typography id="leave-modal-desc" className={styles.subtitle}>
					{subHeader ??
						'Are you sure you want to leave this conversation?'}
				</Typography>

				<Box className={styles.footer}>
					<ButtonCustom
						variant="outlined"
						size="md"
						onClick={onClose}
					>
						Cancel
					</ButtonCustom>

					<ButtonCustom
						variant="destructive"
						size="md"
						onClick={onLeave}
						data-cy="destructive-button"
					>
						{confirmBtnTxt ?? 'Leave'}
					</ButtonCustom>
				</Box>
			</Box>
		</Modal>
	)
}

export default LeaveModal
